import { Alert, Backdrop, Box, Button, Checkbox, CircularProgress, CssBaseline, Grid, Paper, Snackbar, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, styled } from "@mui/material";
import React, { useEffect, useState } from "react";
import { API_REPORTS } from "../../Constants";
import { axiosClient } from "../AxiosClient";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowUpward from "@mui/icons-material/ArrowUpward";
import ArrowBottom from "@mui/icons-material/ArrowDownward";
import dayjs from "dayjs";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const ButtonViews = styled(Button)({
    flexGrow: 0,
    borderRadius: '20px !important',
    gap: '10px !important',
    backgroundColor: '#161e55 !important',
    color: '#ffff !important',
    margin: '0px 1rem !important',
    '&:hover': {
        backgroundColor: '#A8C8AF !important',
    },
})

var formatter = new Intl.NumberFormat('es-US', {
    style: 'currency',
    currency: 'COP',
    // These options are needed to round to whole numbers if that's what you want.
    //minimumFractionDigits: 0, // (this suffices for whole numbers, but will print 2500.10 as $2,500.1)
    //maximumFractionDigits: 0, // (causes 2500.99 to be printed as $2,501)
});

const titles = ["Fondeador","Saldo Capital", "Saldo invertido", "Saldo sin inversión"]
const urlReports = API_REPORTS;

export default function Asignaciones() {
    const [saldosDisponibles, setSaldosDisponibles] = useState();
    const [asignaciones, setAsignaciones] = useState([]);
    const [backdrop, setBackdrop] = useState(false);
    const [texto, setTexto] = useState('');
    const [status, setStatus] = useState('');
    const [message, setMessage] = useState('');
    const [validaciones, setValidaciones] = useState();
    const [selectTodos, setSelectTodos] = useState(false);
    const [check, setCheck] = useState({});
    const [fechaTolerancia, setFechaTolerancia] = useState();
    const [isSnackbar, setIsSnackbar] = useState(false);
    const [severity, setSeverity] = useState();

    const getSaldos = () => {
        setBackdrop(true);
        // setSaldosDisponibles([
        //     {
        //         nombre: "Fondeador 1",
        //         id: 1,
        //         saldo: 1000.50,
        //         saldoDisponible: 800.25,
        //         saldoInvertido: 200.25
        //       },
        //       {
        //         nombre: "Fondeador 2",
        //         id: 2,
        //         saldo: 2000.75,
        //         saldoDisponible: 1500.50,
        //         saldoInvertido: 500.25
        //       },
        //       {
        //         nombre: "Fondeador 3",
        //         id: 3,
        //         saldo: 2000.75,
        //         saldoDisponible: 1500.50,
        //         saldoInvertido: 500.25
        //       }
        // ])
        // setCheck({
        //     1: false,
        //     2: false
        // })
        // setBackdrop(false)
        axiosClient.get('v1/fondeadores/saldos', {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSaldosDisponibles(response.data);
                const items = {};
                response.data.forEach(datos => {
                    items[`${datos.id}`] = false
                })
                setCheck({...items});
                setBackdrop(false);
            } else {
                console.log("Error fetch");
                setBackdrop(false);
            }
        })
        .catch(error => {
            console.log('Error: ' + error.message);
            setBackdrop(false);
        });
    }

    const handleGestion = () => {
        if(fechaTolerancia) {
            const fondeadoresId = [];
            saldosDisponibles.forEach(items => {
                if(check[items.id]) {
                    fondeadoresId.push(items.id);
                }
            });

            if(fondeadoresId.length > 0) {
                const body = {
                    fondeadoresId: fondeadoresId,
                    fecha: fechaTolerancia ? dayjs(`${fechaTolerancia?.$d?.getFullYear()}-${fechaTolerancia?.$d?.getMonth()+1}-${fechaTolerancia?.$D}`).format('YYYY-MM-DD') : null
                }
                setBackdrop(true);
                axiosClient.post(`v1/credits/gestion-saldos`, body)
                .then(response => {
                    if(response.status === 200) {
                        setIsSnackbar(true);
                        setMessage("Se han realizado las asignaciones exitosamente");
                        setSeverity("success");
                        getSaldos()
                    } else {
                        setBackdrop(false);
                        setIsSnackbar(true);
                        setMessage("Ocurrió un error en la asignación, por favor intenta de nuevo mas tarde");
                        setSeverity("error");
                    }
                }).catch(error => {
                    setBackdrop(false);
                    setIsSnackbar(true);
                    setMessage("Ocurrió un error en la asignación, por favor intenta de nuevo mas tarde");
                    setSeverity("error");
                })
            } else {
                setIsSnackbar(true);
                setMessage("Debes seleccionar almenos uno para realizar la asignación de créditos");
                setSeverity("error");
            }

        } else {
            setIsSnackbar(true);
            setMessage("Debes seleccionar una fecha de tolerancia para la asignación");
            setSeverity("error");
        }
    }

    const handleSelectTodos = () => {
        setSelectTodos(!selectTodos);
        
        const items = {};
        Object.keys(check).forEach(datos => {
            items[`${datos}`] = !selectTodos
        });
        setCheck({...items});
    }

    const handleUpward = (index) => {
        if(index != 0) {
            const saldo = saldosDisponibles[index];
            const newSaldo = saldosDisponibles[index-1];
            saldosDisponibles[index-1] = saldo;
            saldosDisponibles[index] = newSaldo;
            setSaldosDisponibles([...saldosDisponibles]);
        }
    }

    const handleBottom = (index) => {
        if(index != saldosDisponibles.length -1) {
            const saldo = saldosDisponibles[index];
            const newSaldo = saldosDisponibles[index+1];
            saldosDisponibles[index+1] = saldo;
            saldosDisponibles[index] = newSaldo;
            setSaldosDisponibles([...saldosDisponibles]);
        }
    }

    const handleFechaTolerancia = (value) => {
        setFechaTolerancia(value);
    }

    const handleClick = (id) => {
        check[id] = !check[id];
        if(selectTodos) {
            setSelectTodos(false);
        }
        setCheck({...check});
    }

    const handleClosedSnack = () => {
        setIsSnackbar(false);
    }

    console.log(check)

    useEffect(() => {
        getSaldos();
        
    },[])

    return (
        <React.Fragment>
            <CssBaseline></CssBaseline>
            <Toolbar></Toolbar>
            <Box sx={{width: '100%', margin: '18px 14px'}}>
                <Stack spacing={2}>
                    <Item>.</Item>
                    <Item></Item>
                    <Grid container>
                        <Grid item xs={6}>
                            <Box mt={2} sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center'}}>
                                <h1>Asignaciones</h1>
                            </Box>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid item>
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DatePicker label="Fecha tolerancia" value={fechaTolerancia} onChange={handleFechaTolerancia}></DatePicker>
                            </LocalizationProvider>
                        </Grid>
                        <Grid item>
                            <ButtonViews onClick={handleGestion} sx={{margin: 'auto'}}>Asignar</ButtonViews>
                        </Grid>
                    </Grid>
                    <Grid container>
                        <Grid sx={{color: 'red'}}>
                            <span>{status === 'Infeasible' ? 'No se cumplen las condiciones para todos los fondeadores' : ''}</span>
                        </Grid>
                        <TableContainer component={Paper}>
                            <Table sx={{minWidth: 650}} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        {titles.map(title => (
                                            <TableCell key={title} align="center">{title}</TableCell>
                                        ))}
                                        <TableCell key={"select"} align="center">
                                            <Checkbox checked={selectTodos} onClick={handleSelectTodos}></Checkbox>
                                        </TableCell>
                                    </TableRow>
                                </TableHead>
                                {saldosDisponibles && (saldosDisponibles.length > 0 ? 
                                    <TableBody>
                                        {saldosDisponibles.map((saldo, index) => (
                                            <TableRow key={saldo.id} sx={{'&:last-child td, &:last-child th': { border: 0 }}}>
                                                <TableCell align="center">{`${saldo.nombre}`}</TableCell>
                                                <TableCell align="center">{`${formatter.format(saldo.saldo)}`}</TableCell>
                                                <TableCell align="center">{`${formatter.format(saldo.saldoInvertido)}`}</TableCell>
                                                <TableCell align="center">{`${formatter.format(saldo.saldoDisponible)}`}</TableCell>
                                                <TableCell key={`select${saldo.id}`} align="center">
                                                    <Checkbox checked={check[`${saldo.id}`] === true} onClick={() => handleClick(saldo.id)}></Checkbox>
                                                </TableCell>
                                                <TableCell>
                                                    <ButtonViews onClick={() => handleUpward(index)}><ArrowUpward></ArrowUpward></ButtonViews>
                                                    <ButtonViews onClick={() => handleBottom(index)}><ArrowBottom></ArrowBottom></ButtonViews>
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                    :
                                    <TableBody>
                                        <TableRow sx={{textAlign: 'center'}}>Ya se han realizado todas las asignaciones</TableRow>
                                    </TableBody>)
                                }
                            </Table>
                        </TableContainer>
                    </Grid>
                </Stack>
            </Box>
            <Backdrop sx={{background: 'rgba(255,255,255,0.1)', zIndex: '5', width: '50%', margin: 'auto auto auto 30vw', display: 'flex', flexDirection: 'column'}} open={backdrop}>
                <CircularProgress color="success"/>
                <span>{texto}</span>
            </Backdrop>
            <Snackbar open={isSnackbar} autoHideDuration={5000} onClose={handleClosedSnack}>
                <Alert onClose={handleClosedSnack} severity={severity} sx={{width: '100%'}}>{message}</Alert>
            </Snackbar>
        </React.Fragment>
    )
}